module.exports = __webpack_public_path__ + "img/wheel.7eb5c913.png";